function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMicrophone = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_827)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.477,
    y: 4.102,
    width: 2.112,
    height: 0,
    style: {
      paintOrder: "stroke",
      stroke: "#000",
      strokeOpacity: 0,
      fill: "var(--status-enabled-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.583a3.12 3.12 0 0 0 3.125-3.125v-6.25A3.12 3.12 0 0 0 12.5 2.083a3.12 3.12 0 0 0-3.125 3.125v6.25a3.12 3.12 0 0 0 3.125 3.125Zm-1.042-9.375c0-.573.47-1.041 1.042-1.041.573 0 1.042.468 1.042 1.041v6.25c0 .573-.47 1.042-1.042 1.042a1.045 1.045 0 0 1-1.042-1.042v-6.25Zm6.25 6.25a5.21 5.21 0 0 1-5.208 5.209 5.21 5.21 0 0 1-5.208-5.209H5.208c0 3.677 2.72 6.698 6.25 7.209v3.208h2.084v-3.208c3.53-.51 6.25-3.532 6.25-7.209h-2.084Z",
    style: {
      fill: "currentColor"
    }
  })));
};
export { SvgMicrophone as ReactComponent };